import styled from 'styled-components';
import { colors } from '../../../../variables/colors.js';
import { deviceWidths } from '../../../../variables/widths.js';

var HotelHitImage = styled.div.withConfig({
  displayName: "hotelHitImage__HotelHitImage",
  componentId: "sc-1qp1zpv-0"
})(["background:", ";display:flex;flex-direction:column;flex-shrink:0;justify-content:center;overflow:hidden;position:relative;width:33%;@media (min-width:", "){max-width:340px;width:50%;}picture.sg-hotel-hit__picture,.sg-hotel-hit__picture img{align-self:center;flex:0 0 auto;height:100%;left:50%;max-width:none;position:absolute;top:50%;transform:translate(-50%,-50%);width:100%;object-fit:cover;}"], colors.extraLightGray, deviceWidths.tablet);

export { HotelHitImage };
//# sourceMappingURL=hotelHitImage.js.map
